// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_GET_COSTOS_PATENTAMIENTO,
  PRESUPUESTADOR_COSTOS_PATENTAMIENTO_CAMBIOS
} from './constants';
import { BFFAgent } from '../../../common/BFFAgent';


export function getCostosPatentamiento(patentamientoData, financiacion, isModoVer, isModoEditar) {
  return async (dispatch, getState) => {

    const { presupuestador = {} } = getState()
    //Se corrobora que el Modal de Reserva no esta activo, si esta no se debe ejecutar la accion.
    // ID-7476 explica porque no se actualizan los costos en esta instancia
    if(presupuestador.modalDeReserva.modalActive) return
    // no ejecutar la consulta si tengo precio de cero
    if(patentamientoData.listPrice === 0 || patentamientoData.totalPrice === 0) return
    let costoPatentamiento = 0
    let costoPatentamientoOriginal = null
    let gastosFin = 0
    const { clientProvince, clientCountry, ...data } = patentamientoData;
    let province = {};
    if(clientProvince && clientCountry ) {
      province = await BFFAgent.Locations.getProvinceById(clientCountry, clientProvince);
    }

    const formattedData = { ...data, clientProvince: province.nombre || '', isPrenda: patentamientoData.isPrenda}
    const costoPatentamientoCalculado = await BFFAgent.Presupuestador.getCostosDePatentamiento(formattedData);
    costoPatentamiento = presupuestador.costoPatentamiento
    costoPatentamientoOriginal = presupuestador.costoPatentamientoOriginal
    const locationMode = location.pathname.split('/')[2]
    const isLastBudgetEdit = locationMode === 'ultimo-editado'
    const isCreationMode = !isModoEditar && !isModoVer && !isLastBudgetEdit
    const hasChangeDeliveryCost = presupuestador?.alerts ? presupuestador?.alerts?.some(item => item.type === "patentCost" || item.type === "priceProduct") : false;

    if(isCreationMode || presupuestador.resetCostoPatentamiento || hasChangeDeliveryCost) {
      costoPatentamientoOriginal = null // Se resetea el valor
      costoPatentamiento = costoPatentamientoCalculado
    }
    if(isModoVer) {
      dispatch( {
        type: PRESUPUESTADOR_COSTOS_PATENTAMIENTO_CAMBIOS,
        data: {
          will_get_costs: false,
          resetCostoPatentamiento: false,
        },
      })
    } else {
      // Calculo los costos de financiación
       if(financiacion){
         gastosFin = (financiacion.capital * financiacion.quebranto / 100) + financiacion.gastos
       }
       dispatch( {
         type: PRESUPUESTADOR_GET_COSTOS_PATENTAMIENTO,
         data: {
           costoPatentamientoOriginal, 
           costoPatentamiento,
           gastosFinanciacion: gastosFin,
           will_get_costs: false,
           resetCostoPatentamiento: !isCreationMode,
         },
       })
    }
    
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_GET_COSTOS_PATENTAMIENTO:
      return {
        ...state,
        ...action.data
      };

    case PRESUPUESTADOR_COSTOS_PATENTAMIENTO_CAMBIOS:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
}
